import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ErrorResponse } from '../../models/general-responses.model';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss'
})
export class AlertMessageComponent implements OnInit, OnChanges {
  @Input() response!: ErrorResponse;
  @Output() onClose = new EventEmitter<boolean>();
  errorType: 'success' | 'error' | 'warning' | 'info' = 'error';
  showModal = false;
  showAlert = false;

  constructor(private messageService: NzMessageService) {}
  
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.mapResponseMode();
  }

  closeAlert() {
    this.showAlert = false;
    this.onClose.emit(false);
  }

  closeModal() {
    this.showModal = false;
    this.onClose.emit(false);
  }

  mapResponseMode() {
    this.mapResponseType();
    switch (this.response.mode) {
      case 'alerts':
        this.response.mode = 'alerts';
        this.showAlert = true;
        break;
      case 'message':
        this.messageService.create(this.errorType, this.response.message, {
          nzDuration: 5000,
          nzAnimate: true,
          nzPauseOnHover: true,
        });
        break;
      case 'modal':
        this.showModal = true;
        break;
    }
  }

  mapResponseType() {
    if (this.response.type === 'fatal' || this.response.type === 'error') {
      this.errorType = 'error';
    } else if (this.response.type === 'warn') {
      this.errorType = 'warning';
    } else if (this.response.type === 'success') {
      this.errorType = 'success';
    } else {
      this.errorType = 'info';
    }
  }
}
